import * as React from "react";
import { Trans } from "react-i18next";
import { IShipment } from "~/graphql/queries/shipment/shipmentsByIds";
import { Order } from "~/helpers/getOrderNumber";

interface IProps {
  order: Order;
  shipment?: IShipment;
}

export default class Delivery extends React.Component<IProps> {
  public render() {
    return (
      <Trans i18nKey="trackTrace:statusExplanation.delivery">
        Je pakketje is afgeleverd! Het kan zijn dat het pakket in je brievenbus
        ligt, of is afgeleverd bij de buren, of dat de bezorger zometeen bij je
        aanbelt.
      </Trans>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrackTrace/Statuses/Delivery.tsx